import React, { useMemo } from 'react';
import { allTimezones } from '../../lib/schedulingApi';

export default function TimezoneSelect({ id, value, onChange, testId }) {
  const zones = useMemo(() => {
    const list = allTimezones();
    return [...new Set([value, 'UTC', ...list].filter(Boolean))];
  }, [value]);
  return (
    <select id={id} className="iv-select" style={{ maxWidth: 260 }} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      {zones.map((z) => <option key={z} value={z}>{z.replace(/_/g, ' ')}</option>)}
    </select>
  );
}
